(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Plans.SeminarPlan",
                    {
                        url: "/SeminarPlan/{seminarPlanId}",
                        component: "seminarplanNew",
                        PageTitle: "Seminar Plan | Marketing Tracker",
                        resolve: {
                            seminarPlanDocument: ["$stateParams", "marketingPlanApi", "marketingTrackerAgent",
                                function ($stateParams, marketingPlanApi, marketingTrackerAgent) {
                                    return marketingPlanApi
                                        .getSeminarPlanDocument(marketingTrackerAgent.AgentId, $stateParams.seminarPlanId)
                                        .then(function (file) {
                                            return URL.createObjectURL(file);
                                        });
                                }]
                        }
                    });
        }
    ]);

    app.component("seminarplanNew",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Plans/SeminarPlan/seminarplan-new-template.html",
            controller: seminarPlanNewController,
            bindings: {
                seminarPlanDocument: "<"
            }
        });

    seminarPlanNewController.$inject = ["$scope"];
    function seminarPlanNewController($scope) {
        var $ctrl = this;

        $scope.$on("$destroy",
            function () {
                if ($ctrl.seminarPlanDocument)
                    URL.revokeObjectURL($ctrl.seminarPlanDocument);
            });
    }

})(window.app);